import { all, takeEvery, put, call } from 'redux-saga/effects'
import { message } from 'antd'

import {
    changeAuthenticationInChat,
    changeSecurityUrl,
    setCurrentApplication,
    setCurrentApplicationLoading
} from './actions'
import {requestSecurityUrlList} from '../SecurityUrl/actions'

import AppsClient from '../../apiClient/AppsClient'
import NowSettingsClient from '../../apiClient/NowSettingsClient'
import {
    LAUNCH_INIT,
    LOAD_CURRENT_APPLICATION_REQUEST,
    CHANGE_WEBHOOK_URL_REQUEST,
    CHANGE_ACCESS_RESTRICTED_REQUEST,
    CHANGE_ALLOW_SECURITY_URL_REQUEST,
    CHANGE_AUTHENTICATION_IN_CHAT_REQUEST,
    CHANGE_NOW_SETTINGS_REQUEST,
    CHANGE_NOW_NOTIFICATION_REQUEST,
} from './constants'

const appsClient = new AppsClient()
const nowSettingsClient = new NowSettingsClient()

function* sagaOnLaunch() {}

function* loadCurrentApplication({ payload }) {
    try {
        const application = yield call(appsClient.getCurrent)
        yield put(setCurrentApplication({ application }))
        yield put(requestSecurityUrlList())
    } catch (e) {
        console.warn(e)
        yield put(setCurrentApplicationLoading(false))
    }
}

function* changeWebhookUrl({ payload: { url } }) {
    try {
        const application = yield call(appsClient.update, { params: { webhook_url: url } })
        yield put(setCurrentApplication({ application }))
        message.success('successfully updated webhook URL')
    } catch (e) {
        console.warn(e)
        message.error('failed to change webhook URL')
        yield put(setCurrentApplicationLoading(false))
    }
}

function* changeAccessTokenRequired({ payload }) {
    try {
        const application = yield call(appsClient.update, { params: { access_token_required: payload } })
        yield put(setCurrentApplication({ application }))
        message.success('successfully changed security permissions')
    } catch (e) {
        console.warn(e)
        message.error('failed to change security permissions')
        yield put(setCurrentApplicationLoading(false))
    }
}

function* changeAllowSecurityUrl({ payload }) {
    try {
        const application = yield call(appsClient.update, { params: { allow_security_url: payload } })
        yield put(setCurrentApplication({ application }))
        message.success('successfully changed security permissions')
    } catch (e) {
        console.warn(e)
        message.error('failed to change security permissions')
        yield put(setCurrentApplicationLoading(false))
    }
}

function* changeAuthenticationChat({payload: { authentication_in_chat }}) {
    try {
        const application = yield call(appsClient.update, { params: { authentication_in_chat: authentication_in_chat } })
        yield put(setCurrentApplication({ application }))
        message.success('successfully changed authentication in chat')
    } catch (e) {
        console.warn(e)
        message.error('failed to change authentication in chat')
        yield put(setCurrentApplicationLoading(false))
    }
}

function* changeNowSettings({ payload }) {
    try {
        const application = yield call(nowSettingsClient.update, { params: payload })
        yield put(setCurrentApplication({ application }))
        message.success('Successfully changed widget parameter')
    } catch (e) {
        console.warn(e)
        message.error('Failed to update settings')
        yield put(setCurrentApplicationLoading(false))
    }
}

function* changeNowNotification({payload: {notification}}) {
    try {
        const application = yield call(nowSettingsClient.update, { params: { notification: notification } })
        yield put(setCurrentApplication({ application }))
        message.success('successfully changed notification')
    } catch (e) {
        console.warn(e)
        message.error('failed to change notification')
        yield put(setCurrentApplicationLoading(false))
    }
}

export default function* appSagas() {
    yield all([
        takeEvery(LAUNCH_INIT, sagaOnLaunch),
        takeEvery(LOAD_CURRENT_APPLICATION_REQUEST, loadCurrentApplication),
        takeEvery(CHANGE_WEBHOOK_URL_REQUEST, changeWebhookUrl),
        takeEvery(CHANGE_ACCESS_RESTRICTED_REQUEST, changeAccessTokenRequired),
        takeEvery(CHANGE_ALLOW_SECURITY_URL_REQUEST, changeAllowSecurityUrl),
        takeEvery(CHANGE_AUTHENTICATION_IN_CHAT_REQUEST, changeAuthenticationChat),
        takeEvery(CHANGE_NOW_SETTINGS_REQUEST, changeNowSettings),
        takeEvery(CHANGE_NOW_NOTIFICATION_REQUEST, changeNowNotification)
    ])
}
